// apps/radar/src/routes/review.tsx
// Version: 2026.4.24

import { createFileRoute } from '@tanstack/react-router';
import {
  EnginePageShell, GlassPanel, SectionLabel, EmptyState, LoadingShimmer,
  C, F,
} from '../components/engine';
import { useReviewQueue } from '../lib/api/hooks';

export const Route = createFileRoute('/review')({ component: ReviewPage });

function ReviewPage() {
  const { data, loading, error } = useReviewQueue();

  return (
    <EnginePageShell
      title="Review Queue"
      subtitle="HUMAN CONFIDENCE LOOP"
      icon="🔬"
      accentColor={C.amber}
      brand="FORGERADAR"
      footer="ForgeRadar · Edson Technologies · forgeradar.app"
    >
      <GlassPanel accent={C.amber}>
        <SectionLabel color={C.amber}>Low-Confidence Classifications</SectionLabel>

        {error && (
          <div style={{ padding: '24px 0', color: C.coral }}>
            Failed to load review queue: {error.message}
          </div>
        )}

        {!error && loading && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, padding: '12px 0' }}>
            {Array.from({ length: 4 }).map((_, i) => <LoadingShimmer key={i} height={32} />)}
          </div>
        )}

        {!error && !loading && (data?.length ?? 0) === 0 && (
          <EmptyState
            icon="🔬"
            title="No items awaiting review"
            subtitle="Classifications below the confidence threshold (default 0.7) appear here for human approval, override, or rejection. Corrections feed the prompt-improvement loop."
          />
        )}

        {!error && !loading && data && data.length > 0 && (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {data.map(item => (
              <div key={item.leadId} style={{
                padding: '14px 4px',
                borderBottom: `1px solid ${C.faint}`,
              }}>
                <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, marginBottom: 4 }}>
                  <span style={{
                    fontFamily: F.mono, fontSize: 11,
                    color: item.confidence < 0.5 ? C.coral : C.amber,
                    letterSpacing: '0.1em',
                  }}>
                    {(item.confidence * 100).toFixed(0)}% conf
                  </span>
                  <span style={{ color: C.text, fontSize: 14 }}>{item.title}</span>
                  <span style={{
                    marginLeft: 'auto', fontFamily: F.mono, fontSize: 11, color: C.muted,
                  }}>
                    {item.category}
                  </span>
                </div>
                <div style={{ color: C.muted, fontSize: 12, lineHeight: 1.5 }}>
                  {item.rationale}
                </div>
              </div>
            ))}
          </div>
        )}
      </GlassPanel>
    </EnginePageShell>
  );
}
